import React from 'react';
import { GoogleAnalyticsInit } from '../../Analytics/googleAnalytics';

type Props = {
  children: React.ReactNode;
};

export const LayoutWithGA: React.FC<Props> = ({ children }) => {
  return (
    <>
      <GoogleAnalyticsInit />

      {children}
    </>
  );
};
